module.exports = __webpack_public_path__ + "media/src/images/partners/unep-262500e32d511bb12ab7c2ba98c1de78.jpg";